export default "__VITE_ASSET__BSrHtkzC__"